import posthog from 'posthog-js'
import { useEffect } from 'react'
import { hasAnalyticsConsent } from '../utils/cookieConsent'

let initialized = false

const isAnalyticsEnabled = () =>
  process.env.REACT_APP_ENABLE_POSTHOG === 'true' && hasAnalyticsConsent()

export const initPostHog = () => {
  if (initialized) return
  if (isAnalyticsEnabled()) {
    initialized = true
    posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
      api_host: `${window.location.origin}/ph`, // Use your own domain
      autocapture: true,
      capture_pageview: false, // Disable automatic pageview capture
      persistence: 'localStorage',
      person_profiles: 'always',
      loaded: (posthog) => {
        if (process.env.NODE_ENV === 'development') posthog.debug()
      }
    })
  } else {
    console.log('PostHog is disabled')
  }
}

// Every call site shares this wrapper so consent + the feature flag are
// enforced in one place, instead of each caller having to remember to check
// (Register.js's capture calls used to fire unconditionally).
const safePosthog = {
  capture: (...args) => {
    if (isAnalyticsEnabled()) posthog.capture(...args)
  },
  identify: (...args) => {
    if (isAnalyticsEnabled()) posthog.identify(...args)
  },
  reset: (...args) => {
    if (isAnalyticsEnabled()) posthog.reset(...args)
  },
}

const usePostHog = () => {
  useEffect(() => {
    initPostHog()
  }, [])

  return safePosthog
}

export default usePostHog
